/* eslint max-classes-per-file: 0 */

import { CollectorPublication as Data } from '@/typings/api/CollectorPublication'
import { AxiosRequestConfig } from 'axios'

import { BaseCollectorApiAuth } from '@/api/BaseApiAuth'

export class CollectorTasksInfo extends BaseCollectorApiAuth<Data> {
  protected readonly endpoint = 'tasks/';

  protected readonly hasFinishSlash = false;

  public getTasksInfo(publication_id: Data['publication_id'], params?: unknown, config: AxiosRequestConfig = {}) {
    const path = `publication/${publication_id}`
    const [url] = this.getUrl(path)
    return this.request('GET', url, { params, ...config })
  }
}
